module.exports = __webpack_public_path__ + "static/media/30OIOS10.272a5b3d.jpg";